import { catchAllRoutes } from "@/routes/constants.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";
import lazyFn from "@/util/lazy-fn.mjs";
import pathRegExp from "@/util/path-regexp.mjs";

const fetchWikiData = lazyFn(
  () => import("@/game-minecraft/fetches/fetch-wiki-data.mjs"),
);

const fetchNews = lazyFn(() => import("@/game-minecraft/fetches/news.mjs"));

const fetchArticle = lazyFn(
  () => import("@/shared/fetch-contentful-article.mjs"),
);

export const routes: BaseRoute[] = [
  {
    path: "/minecraft/database",
    component: "game-minecraft/DatabaseLanding.tsx",
    fetchData: () => fetchWikiData(),
  },
  {
    path: /\/minecraft\/database\/blocks(?:\/(?<name>[\w\-_.~]+))?/,
    component: "game-minecraft/DatabaseBlocks.tsx",
    fetchData: () => fetchWikiData(),
  },
  {
    path: /\/minecraft\/database\/items(?:\/(?<name>[\w\-_.~]+))?/,
    component: "game-minecraft/DatabaseItems.tsx",
    fetchData: () => fetchWikiData(),
  },
  {
    path: /\/minecraft\/database\/mobs(?:\/(?<name>[\w\-_.~]+))?/,
    component: "game-minecraft/DatabaseMobs.tsx",
    fetchData: () => fetchWikiData(),
  },
  {
    path: "/minecraft/news",
    component: "game-minecraft/News.tsx",
    fetchData: fetchNews,
  },
  {
    path: pathRegExp("/minecraft/article/:id"),
    component: "game-minecraft/Article.tsx",
    fetchData: fetchArticle,
  },
];

routes.push({
  [catchAllRoutes]: routes,
  fetchData: () => {
    fetchWikiData();
  },
});
